module.exports = __webpack_public_path__ + "static/media/oeuf-au-plat.737507d2.svg";